/**
 * The band above the application: what this demo is, and how to get the rest.
 *
 * Above the app's own top bar rather than inside it, because it is not part of
 * the tool - it addresses the visitor, not the user. It carries the brand
 * gradient, which is the one place on the screen that should: everything below
 * is a working surface and stays neutral.
 *
 * The file count is the library's real one rather than a number written into the
 * copy. A sentence claiming seven drawings above a grid showing eight is the
 * kind of small wrongness that makes a viewer doubt the rest of the screen.
 */
import { Icon } from "./primitives";

export function PromoBar({ documents, onContact }: { documents: number; onContact: () => void }) {
  return (
    <div className="promobar">
      <Icon name="lock_open_right" size={16} className="promobar__icon" />
      <p className="promobar__copy">
        This demo is a limited version with{" "}
        <strong>{documents > 0 ? documents : "a few"} pre-defined files</strong>. If you want to
        test it on your own drawings, get in touch.
      </p>
      <button className="promobar__cta" onClick={onContact}>
        Contact us
      </button>
    </div>
  );
}
